import { useState, useEffect } from 'react'

import { JobResp, JobType } from '@/module/sea/game-jobs/types'
import {
  jobSwitchBtnConfig as jobSwitchBtnConfigV1,
  jobSwitchBtnConfigV2,
} from '@/module/hmt/game-jobs/utils'

/**
 * 返回轉職按鈕的配置
 * @param jobData
 * @param currJobIdx
 */
const useJobSwitchBtnConfig = (jobData: JobResp, currJobIdx: number) => {
  // 對應 index 為 true，表示該職業有 二之二轉和進階二之二轉
  const [btnConfigV2Flag, setBtnConfigV2Flag] = useState<boolean[]>([])

  useEffect(() => {
    setBtnConfigV2Flag(
      jobData.map(
        (item) =>
          item.sub_role?.some((ele) =>
            [JobType.Type22, JobType.Type2s2, JobType.Type3, JobType.Type32].includes(ele?.type as JobType)
          ) ?? false
      )
    )
  }, [jobData])

  return {
    jobSwitchBtnConfig: btnConfigV2Flag[currJobIdx]
      ? jobSwitchBtnConfigV2
      : jobSwitchBtnConfigV1,
    btnConfigV2Flag,
  }
}

export default useJobSwitchBtnConfig
